import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() value: string;
  @Input() position: string;
  @Input() large: false;
  @Input() hasNextArrow: false;
  @Input() hasPrevArrow: false;
  @Input() disabled: false;

  constructor() { }

  ngOnInit() {
  }

}
